import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "user-stats" }

import { computed, toRefs } from 'vue'

  import StatCard from '@/components/Common/StatCard.vue'
  import { IAppStatistics } from '@/types/application'
  import { getReadableFileSize } from '@/utils/files'

  interface Props {
    appStatistics: IAppStatistics
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    appStatistics: null
  },
  setup(__props: any) {

const props = __props as {
    appStatistics: IAppStatistics
  }

  

  const { appStatistics } = toRefs(props)
  const uploadDirSize = computed(() =>
    getReadableFileSize(appStatistics.value.uploads_dir_size, false)
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatCard, {
      icon: "users",
      value: _unref(appStatistics).users,
      text: _ctx.$t('admin.USER', _unref(appStatistics).users)
    }, null, 8, ["value", "text"]),
    _createVNode(StatCard, {
      icon: "tags",
      value: _unref(appStatistics).sports,
      text: _ctx.$t('workouts.SPORT', _unref(appStatistics).sports)
    }, null, 8, ["value", "text"]),
    _createVNode(StatCard, {
      icon: "calendar",
      value: _unref(appStatistics).workouts,
      text: _ctx.$t('workouts.WORKOUT', _unref(appStatistics).workouts)
    }, null, 8, ["value", "text"]),
    _createVNode(StatCard, {
      icon: "folder-open",
      value: _unref(uploadDirSize).size,
      text: _unref(uploadDirSize).suffix
    }, null, 8, ["value", "text"])
  ]))
}
}

})